import { NODE_TITLE, TRPL_SELECT_PLACEHOLDER } from './constants';
import { get, zipObject } from './utils/lodash';
import axios from 'axios';

export const isHTMLString = (str) => {
  return /<[a-z][\s\S]*>/i.test(str);
};

// get url extension/file type
export const getUrlExtension = (url) => {
  return url.split(/[#?]/)[0].split('.').pop().trim();
}

//get really random number
export const getRandomId = () => {
  const randomNumber = new Date().getTime();
  return (+(Array.from(randomNumber.toString()).join('')));
};

// URL utils:
// TODO let react router do this job

export const getUrlParameter = (name, url) => {
  if (!url) url = window.location.href;
  // eslint-disable-next-line
  name = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2]);
};

export const setUrlParameter = (key, value) => {
  let uri = window.location.href;
  let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  let separator = uri.indexOf('?') !== -1 ? '&' : '?';
  let result;

  if (uri.match(re)) {
    result = uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    result = uri + separator + key + '=' + value;
  }

  window.history.pushState(null, null, result);
};

export const removeUrlParameter = (key) => {
  const sourceURL = window.location.href;

  let rtn = sourceURL.split('?')[0],
    param,
    params_arr = [],
    queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
  if (queryString !== '') {
    params_arr = queryString.split('&');
    for (let i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    rtn = rtn + `${params_arr && params_arr.length ? '?' + params_arr.join('&') : ''}`;
  }

  window.history.pushState(null, null, rtn);
};

export const getPagelocation = () => {
  const sourceURL = window.location.href;
  const index = sourceURL.lastIndexOf("/") + 1;
  const filenameWithExtension = sourceURL.substr(index);
  const filename = filenameWithExtension.split(".")[0].split('?')[0];

  return filename;
};

export const validateEmail = (val) => {
  // eslint-disable-next-line
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(val).toLowerCase());
};

export const isObjectPredicate = (rst) => rst.type === 'OBJECT';

export const getJsonValue = (keys, data) => {
  if (!keys) return '';

  let tripleData = data;

  let val;

  keys.forEach((currentKey, index) => {
    if (index === keys.length - 1) {
      val = tripleData[currentKey] || '';
    } else if (tripleData[currentKey]) {
      tripleData = tripleData[currentKey];
    } else {
      val = '';
    }
  });

  return val;
};

export const isRestrictionOverriden = (rst) => rst.overridden_by > 0;

export const getRandomInteger = (min, max) => {
  return Math.round(min - 0.5 + Math.random() * (max - min + 1));
};

export const objectToQuerystring = (obj) => {
  return Object.keys(obj).reduce(function (str, key, i) {
    let delimiter, val;
    delimiter = i === 0 ? '' : '&';
    key = encodeURIComponent(key);
    val = encodeURIComponent(obj[key]);
    return [str, delimiter, key, '=', val].join('');
  }, '');
};

export const colors = [
  '#DB7676',
  '#EB6C91',
  '#DEA6E0',
  '#CCB139',
  '#EBCD49',
  '#EDA509',
  '#68cab6',
  '#79d4da',
  '#789FC2',
  '#a285c5',
];

export const getNodeColor = (nodeId) => {
  return colors[nodeId % 10];
};

export const getNodeAvatar = (node, size) => {
  const nodeImgSrc = `${node.pic.path}/${node.pic.fldr}${size}/${node.pic.name}`
  return nodeImgSrc;
};

export const changeArrayElementPosition = (arr, oldIndex, newIndex) => {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }

  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
};

export const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};

export const onlyUniqueByField = fieldName => (
  (rst, index, self) => {
    const sameField = testedRst => testedRst[fieldName] === rst[fieldName];
    return self.findIndex(sameField) === index;
  }
)

// Filter utils:

export const getFilterRstTitle = filter => filter.pids_chain ? filter.pids_chain.join('.') : '';

export const getFilterPidsChain = filterRstTitle =>
  filterRstTitle ? filterRstTitle.toString().split('.') : [];

// Use this only with cleaned filters
export const isFilterHasValues = filter => filter.val || filter.val === false || !!filter.func;

export const isNotPlaceholderFilter = filter => {
  return getFilterRstTitle(filter) !== TRPL_SELECT_PLACEHOLDER
};

export const isNotSearchFilter = filter => {
  return getFilterRstTitle(filter) !== NODE_TITLE
};

// Use this function to have a single source of filter structure
export const generateFilter = (rstIdTitle, val, func, op, con) => {
  const newFilter = {
    pids_chain: getFilterPidsChain(rstIdTitle),
    con: 'AND'
  };

  if (val || val === false) newFilter.val = val;
  if (func) newFilter.func = func;
  if (op) newFilter.op = op;
  if (con) newFilter.con = con;

  return newFilter;
};

export const getFilterReadyForBackend = filter => {
  const filterWithoutShow = {
    pids_chain: filter.pids_chain,
  };

  if (filter.op !== '') {
    if (filter.showFunc) {
      filterWithoutShow.func = filter.func
    } else {
      filterWithoutShow.val = filter.val;
    }
  }

  if (filter.op || filter.op === '') filterWithoutShow.op = filter.op;
  if (filter.con) filterWithoutShow.con = filter.con;

  return filterWithoutShow;
};

export const getFilterReadyForFrontend = filter => ({ ...filter, showFunc: filter.hasOwnProperty('func')});

export const encodeFilterForUrl = filter => {
  const filterForEncoding = { ...filter };

  if (filterForEncoding.func) {
    filterForEncoding.func = encodeURIComponent(filterForEncoding.func);
  }

  if (filterForEncoding.val) {
    filterForEncoding.val = encodeURIComponent(filterForEncoding.val);
  }

  return filterForEncoding;
}

export const decodeFilterFromUrl = filter => {
  const filterForDecoding = { ...filter };

  if (filterForDecoding.func) {
    filterForDecoding.func = decodeURIComponent(filterForDecoding.func);
  }

  if (filterForDecoding.val) {
    filterForDecoding.val = decodeURIComponent(filterForDecoding.val);
  }

  return filterForDecoding;
}

//getRstDataMap for filters rst dropdown list
export const getRstDataMap = (pidsArray, ancestor, nodes, predParams) => {
  const rstDataMap = new Map();

  if (!ancestor || !nodes) return rstDataMap;

  if (!pidsArray) {
    let restrictionsByConcepts;
    if (nodes[ancestor]) restrictionsByConcepts = nodes[ancestor].box.r || {};
  
    const rstList = Object.values(restrictionsByConcepts).flat();
  
    rstList.forEach(rst => {
      rstDataMap.set(rst.id.toString(), rst);
    });

  } else {
    pidsArray.forEach(id => {
      if (!Array.isArray(id)) id = [id];
      let thisAncestor = ancestor;
  
      if (nodes && nodes[thisAncestor] && nodes[thisAncestor].box.r) {
        const rstChainArr = id;
        let lastChainRst = getLastRstData(id, thisAncestor, nodes, predParams);
  
        if (lastChainRst) {
          const chainIdsJoined = rstChainArr.join('.');
          const joinedRstTitle = getChainTitle(rstChainArr, ancestor, nodes, predParams);
  
          const chainRst = {
            ...lastChainRst,
            title: joinedRstTitle,
            id: chainIdsJoined,
          };
  
          rstDataMap.set(chainIdsJoined, chainRst);
        };
      }      
    });
  }

  return rstDataMap;
};


// Emogi utils
export const emojiesSuccess = ['\uD83E\uDD79', '\u2728', '\uD83D\uDD25', '\uD83E\uDD73', '\uD83E\uDD29', '\uD83D\uDE38', '\uD83D\uDC8E', '\uD83D\uDE80'];
export const emojiesRedirect = ['\uD83D\uDE24', '\uD83D\uDE43', '\uD83D\uDC7D', '\uD83D\uDE3C', '\uD83E\uDD16'];


// Trpls utils:

export const extractPidValue = (str) => {
  const regex = /\$\{(\d+)\}/;
  const match = str.match(regex);
  if (match) {
    return match[1];
  }
  return null;
};

// export const shouldShowTrplAsEdited = trpl => trpl && trpl.edited && trpl.val.toString() !== trpl.oldVal.toString();
export const shouldShowTrplAsEdited = trpl => trpl
  && (((trpl.val || (trpl.val === '') || (trpl.val === false))

    && (trpl.oldVal || (trpl.oldVal === '') || (trpl.oldVal === false))

      && trpl.val.toString() !== trpl.oldVal.toString())
      
        || (((!trpl.tz || trpl.tz || (trpl.tz === '') || (!trpl.units || trpl.units || (trpl.units === '')))

          && (trpl.oldAd || (trpl.oldAd === ''))
          
            && ((trpl.tz && trpl.tz.toString() !== trpl.oldAd.toString()) || (trpl.units && trpl.units.toString() !== trpl.oldAd.toString()))
      )));

// EditUi utils:
const [FORM_JEL_TYPE, TABLE_JEL_TYPE] = ['forms', 'tables'];

export const getJelSelectValues = (jels, jelConcept, nodes, type) => jels[type]
    .map(jelId => jels.jelData[jelId])
    .filter(Boolean)
    .filter(jel => {
      if (!jelConcept) return true;

      return jel.concept === jelConcept || (
        nodes &&
        nodes[jelConcept] &&
        nodes[jelConcept].box &&
        nodes[jelConcept].box.t_supers_implicit &&
        nodes[jelConcept].box.t_supers_implicit.includes(jel.concept)
      )
    })
    .map(jel => ({ title: `${jel.id} ${jel.title}`, value: jel.id }));

export const getFormsSelectValues = (jels, conceptId, nodes) => {
  const formsSelectValues = getJelSelectValues(jels, conceptId, nodes, FORM_JEL_TYPE)
    .filter(selectVal => jels.importedForms.includes(selectVal.value) || !jels.jelData[selectVal.value].is_dashboard);

  formsSelectValues.unshift({ title: 'none', value: 'none' });
  return formsSelectValues;
};


export const getTablesSelectValues = (jels, concept) => {
  const tablesSelectValues = getJelSelectValues(jels, concept, null, TABLE_JEL_TYPE);

  tablesSelectValues.unshift({ title: 'none', value: 'none' });
  return tablesSelectValues;
};

export const getLinksSelectValues = (jels) => {
  const tablesSelectValues = getJelSelectValues(jels, null, null, TABLE_JEL_TYPE);
  const formsSelectValues = getJelSelectValues(jels, null, null, FORM_JEL_TYPE)
    .filter(selectVal => !jels.jelData[selectVal.value].is_dashboard);;

  if (tablesSelectValues.length) {
    tablesSelectValues.unshift({ title: 'Tables', value: '', disabled: true });
  }
  if (formsSelectValues.length) {
    formsSelectValues.unshift({ title: 'Forms', value: '', disabled: true });
  }

  return [{ title: 'none', value: 'none' }, ...tablesSelectValues, ...formsSelectValues];
}

//collect Nodes ids from Graph Trigger
export const getNodesIdsFromGraphTrigger = (currentItemsArray, setup_rbox_light) => {
  const nodes = [];
  for (let item of currentItemsArray) {
    const graphTrigger = item.trigger;
    if (graphTrigger) {
      if (graphTrigger.ancestor && nodes.indexOf(+graphTrigger.ancestor) === -1) nodes.push(+graphTrigger.ancestor);
      for (let trpl of graphTrigger.trpls) {
        const rst = getLastRstData(trpl.pids_chain, graphTrigger.ancestor, setup_rbox_light);
        if (rst && isObjectPredicate(rst) && +trpl.val && nodes.indexOf(+trpl.val) === -1) nodes.push(+trpl.val);
      }
    }
  }
  return nodes;
};

//Predicates utils:
//use this function for finding rst data by single predicate id or last rst data in predicate chain
export const getLastRstData = (chain, ancestor, setup_tbox, prdcParams, boxParams) => {
  if (!chain || !ancestor || !setup_tbox) return;

  let lastPredicateData;

  if (Array.isArray(chain) && chain.length) {
    let thisAncestor = ancestor;

    chain.forEach(pid => {
      let rstList = getConceptRsts(thisAncestor, setup_tbox, prdcParams, boxParams);
      lastPredicateData = rstList.find(rst => +pid === +rst.id);
      if (lastPredicateData && lastPredicateData.oid) thisAncestor = lastPredicateData.oid;
    });

  } else {
    let ancestorsRstList = getConceptRsts(ancestor, setup_tbox, prdcParams, boxParams);
    lastPredicateData = ancestorsRstList.find(rst => +rst.id === +chain);
  }

  return lastPredicateData;
};

export const findLastRstInPredicateChain = (chain, data, ancestor, prdcParams, boxParams) => {
  if (!data.nodes) return;
  let rst;
  rst = getLastRstData(chain, ancestor, data.nodes, prdcParams, boxParams);
  if (!rst) return;

  rst.id = chain;
  return rst;
};

export const editRstMacroArgs = (index, argumentName, value, macro) => {
  if (!macro.args) macro.args = [];
  if (index === -1) macro.args.push({});

  if (argumentName && value) macro.args[index][argumentName] = value;

  if (argumentName === 'type' && value !== 'NODE') {
    delete macro.args[index].concept;
  }

  if (argumentName && !value) delete macro.args[index][argumentName];

  if (argumentName && !value && !Object.values(macro.args[index]).length) {
    macro.args.splice(index, 1);
  }
};

//get full concepts' rsts list
export const getConceptRsts = (concept, setup_tbox, prdcParams, boxParams) => {
  if (!concept || !setup_tbox) return;

  let rstList = [];
  let box;
  if (setup_tbox[concept] && setup_tbox[concept].box) {
    box = boxParams && Array.isArray(setup_tbox[concept].box) ? zipObject(boxParams, setup_tbox[concept].box) : setup_tbox[concept].box;
  }

  if (box && box.r) {
    Object.values(box.r).forEach(rsts => {
      if (rsts[0] && Array.isArray(rsts[0]) && prdcParams) {
        let zippedList = rsts.map(rst => zipObject(prdcParams, rst));
        rstList = [...rstList, ...zippedList];
      } else {
        rstList = [...rstList, ...rsts];
      }
    });
  }

  return rstList;
}

export const getAllRstsAsArray = (light_meta_and_ops) => {
  const setup_rbox_light = light_meta_and_ops ? light_meta_and_ops.setup_rbox_light : null;
  const rsts = [];

  if (setup_rbox_light) {
    for (const cid of Object.keys(setup_rbox_light)) {
      const rstsByCid = get(setup_rbox_light, [cid, 'box', 'r', cid], []);
      rsts.push(...rstsByCid);
    }
  }

  return rsts.sort((rst1, rst2) => rst1.id - rst2.id);
};

export const getAllRstsAsObject = (light_meta_and_ops) => {
  const setup_rbox_light = light_meta_and_ops ? light_meta_and_ops.setup_rbox_light : null;
  const rsts = {};

  if (setup_rbox_light) {
    for (const cid of Object.keys(setup_rbox_light)) {
      const rstsByCid = get(setup_rbox_light, [cid, 'box', 'r', cid], []);
      for (const rst of rstsByCid) rsts[rst.id] = rst;
    }
  }

  return rsts;
};

//TrplsTable get column title and id for any column type
export const getColumnTitle = (column) => {
  let columnTitle = column.column_title || column.title;
  if (Array.isArray(column) && column[0] && isJsonObject(column[0])) {
    columnTitle = column[0].column_title ? column[0].column_title : column.map(item => item.title).join(' / ');
  } else if (isJsonObject(column) && column.type && column.type === 'custom') {
    columnTitle = column.column_title ? column.column_title : column.usedPids.map(item => item.title).join(' / ');
  }
  return columnTitle;
};

export const getColumnId = (column) => {
  let rstChainId = column.chainTitle || column.id;
  if (Array.isArray(column) && column[0] && isJsonObject(column[0])) {
    rstChainId = column.map(item => item.pids ? item.pids : '').join(' / ');
  } else if (isJsonObject(column) && column.type && column.type === 'custom') {
    rstChainId = column.usedPids.map(item => item.chain ? item.chain.join('.') : '').join(' / ');//!attention to join()
  }
  return rstChainId;
};

//get chain title where rst is array for TrplsTable && getRstDataMap
export const getChainTitle = (chain, ancestor, nodes, prdcParams, boxParamsTable) => {
  const title = [];
  let thisAncestor = ancestor;
  chain.forEach(pid => {
    let rstList = getConceptRsts(thisAncestor, nodes, prdcParams, boxParamsTable);
    let item = rstList && rstList.find(rst => {
      if (Array.isArray(rst)) {
        return +pid === +rst[prdcParams.indexOf("id")]
      } else {
        return +pid === +rst.id
      }
    });
    if (item) {
      let rst = Array.isArray(item) ? zipObject(prdcParams, item) : item;
      title.push(rst.title);
      if (rst.oid) thisAncestor = rst.oid;
    }
  });

  return title.join('.');
};

//get all form view concepts
export const getAllFormConcepts = (form) => {
  const concepts = {};

  for (let key in form) {
    if (key.startsWith('concept')) {
      concepts[key] = form[key];
    }
  }

  return concepts;
};

//TrplFormRow get ancestors array for chain trpl
export const getChainConceptsArray = (chain, ancestor, nodes, prdcParams, boxParams) => {
  const concepts = [];
  let thisAncestor = ancestor;

  chain.forEach(pid => {
    let rstList = getConceptRsts(thisAncestor, nodes, prdcParams, boxParams);
    let item = rstList && rstList.find(rst => {
      if (Array.isArray(rst)) {
        return +pid === +rst[prdcParams.indexOf("id")]
      } else {
        return +pid === +rst.id
      }
    });
    if (item) {
      let rst = Array.isArray(item) ? zipObject(prdcParams, item) : item;
      concepts.push(rst.sid);
      if (rst.oid) thisAncestor = rst.oid;
    }
  });

  return concepts;
}

//get_view & pnkqry render params for TrplsTable and TrplForm
export const nodesParams = ["title","box","color","is_individ","ontology"];
export const trplsParamsTable = ["tid","sid","oid","val","type","metadata","virtual","tz","warnings","units","val_fuzzy"];
export const trplsParamsTableMatching = [...trplsParamsTable,"upd_time","val_bool"];
export const trplsParamsForm = ["tid","oid","val","type","metadata","virtual","inverted","tz","warnings","units","val_fuzzy"];//upd_time
export const prdcParamsTable = ["id","title","sid","oid","type","locale_correction","overridden_by","isConstant","values","subjectMaxBound","btn_title",
  "subjectMinBound","timezones","units"];
export const contactParams = ["body","timestamp","incoming","type","isSeen","contact_info","ancestors","unseen"];

export const prdcParamsForm =
  ["id","title","sid","oid","type","inverted","values","subjectMaxBound","subjectMinBound",
    "btn_title","isTitle","render_parts","locale_correction","overridden_by","has_def_val","isConstant","is_bounds_strict","timezones","units"];

export const boxParamsForm = ["a_bottom","a","r"];
export const boxParamsTable = ["t_supers_implicit","r"];

//get trpls for TrplsTable from get_view query array
export const getTransformedTrplsArrayToObj = (trpls, nodeId, params) => {
  let newTrpls = {};

  if (trpls[nodeId]) Object.values(trpls[nodeId]).forEach((trplsArr, index)=> {
    const pid = Object.keys(trpls[nodeId])[index];

    let zippedTrpls = trplsArr.map(trpl => {
      const newTrpl = zipObject(params, trpl);
      newTrpl.pid = +pid;
  
      return newTrpl;
    });
    newTrpls[pid] = zippedTrpls;
  });

  return newTrpls;
};

//get nodes for TrplsTable and TrplForm from get_view query array
export const getTransformedNodesArrayToObj = (nodes, params) => {
  let newInds = {};

  Object.values(nodes).forEach((node, index)=> {
    const nodeId = Object.keys(nodes)[index];
    let newNode = zipObject(params, node);
    // Preserve the original box structure
    if (nodes[nodeId].box) {
      newNode.box = nodes[nodeId].box;
    }
    newNode.id = +nodeId;
    newInds[nodeId] = newNode;
  });

  return newInds;
};

export const downloadFile = (url, fileName, useSiteProtocol) => {

  if (useSiteProtocol) {
    const siteProtocol = window.location.protocol;
    if (!url.startsWith(siteProtocol)) {
      let urlWithoutProtocol;
      if (url.startsWith('http:')) urlWithoutProtocol = url.substring(5);
      else if (url.startsWith('https:')) urlWithoutProtocol = url.substring(6);

      if (urlWithoutProtocol) url = siteProtocol + urlWithoutProtocol;
    }
  }

  axios({
    url: url,
    method: 'GET',
    responseType: 'blob'
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }).catch((error) => {
    console.log(error);
  });
};

export const hasPageHorizontalScrollbar = () => {
  return window.innerWidth > document.documentElement.clientWidth;
};

export const clearHtml = (data) => {
  if (!data) return data;
  return data.replaceAll(/<.*?>/g, '');
};

export const isJsonObject = (data) => {
  if (!data) return;
  try {
    JSON.parse(JSON.stringify(data));
  } catch (e) {
    console.log(e);
    return;
  }
  return data.constructor === {}.constructor;
};

export const getPidsFromShowPids = (showPidEl) => {
  if (Array.isArray(showPidEl) && isJsonObject(showPidEl[0])) {
    return showPidEl;
  } else if (Number.isInteger(showPidEl) || Array.isArray(showPidEl)) {
    return showPidEl;
  } else if (showPidEl.pids && isJsonObject(showPidEl)) {
    return showPidEl.pids;
  } else return null
};


//compare json structure, only keys and nested structures
export const compareJsonStructure = (json1, json2) => {
  // Check if both inputs are objects
  if (typeof json1 !== 'object' || typeof json2 !== 'object') {
    return false;
  }

  // Get the keys of the JSON objects
  const keys1 = Object.keys(json1);
  const keys2 = Object.keys(json2);

  // Check if the keys are the same
  // if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) {
  //   return false;
  // }

  // // Recursively check the structure of nested objects
  // for (let key of keys1) {
  //   const val1 = json1[key];
  //   const val2 = json2[key];

  //   if (typeof val1 === 'object' && typeof val2 === 'object') {
  //     // Recursive call for nested objects
  //     if (!this.compareJsonStructure(val1, val2)) {
  //       return false;
  //     }
  //   } else if (Array.isArray(val1) && Array.isArray(val2)) {
  //     // Check if lengths of arrays are different
  //     if (val1.length !== val2.length) {
  //       return false;
  //     }
  //     // Recursive call for nested arrays
  //     for (let i = 0; i < val1.length; i++) {
  //       if (!this.compareJsonStructure(val1[i], val2[i])) {
  //         return false;
  //       }
  //     }
  //   }
  // }

  return true;
}
